<div class="ag-modal-container">
    <div class="modal-close-button">
        <img src="../../../assets/icons/close.svg" (click)="closeModal()" width="24px"/>
    </div>
    <ng-content></ng-content>
</div>
